<div *ngIf="largeStyle" (click)="onCardClick()" class="home-card-container grid grid-cols-[auto_1fr] h-30 px-2 py-2 xl:px-3 xxl:px-4 xl:py-3 rounded-lg border-[0.5px]" [ngClass]="customClass ? customClass : '' ">
  <div class="flex justify-center items-center border-r-2 border-gray-250 pr-2 xxl:pr-3 xxxl:pr-4">
    <ng-content select="[cardImage]"></ng-content>
  </div>

  <div class="flex flex-col justify-center gap-1 pl-3 xxl:pl-4 relative">
    <ng-content select="[cardInfo]"></ng-content>
    <div class="absolute bottom-[-5px] -right-1  xl:bottom-[-10px] xl:-right-[6px]">
      <ng-content select="[cardAction]"></ng-content>
    </div>
  </div>
</div>

<div *ngIf="!largeStyle" (click)="onCardClick()" class="cursor-pointer shadow-normal flex flex-col gap-1 items-center justify-center w-full rounded-default">
  <div class="py-1 px-3 flex flex-col gap-[2px] items-center justify-center w-full bg-white">
      <ng-content select="[cardTitle]"></ng-content>
      <div class="w-[fit-content] grid grid-cols-[auto_1fr] gap-1 items-center">
        <ng-content select="[cardImageSm]"></ng-content>
        <ng-content select="[cardNumberSm]"></ng-content>
      </div>
  </div>
  <div class="bg-primary flex justify-center items-center text-white w-full p-1 rounded-b-default">
    <ng-content select="[cardLabelSm]"></ng-content>
  </div>
</div>


